export default (value, format = 'default') => {
    let temp = value;
    if (temp === null || temp === undefined) {
        return null;
    }

    if (temp === 'now') {
        temp = window.moment();
    }

    if (format === 'server') {
        return window.moment.utc(temp).format('YYYY-MM-DD HH:mm');
    }

    return window.moment(temp).format('DD/MM/YYYY HH:mm');
};
